import { ApiError } from './types';
import { resolveMessage } from './messages.tr';

export interface ToastPayload {
  variant: 'destructive';
  title: string;
  description: string;
}

export type ToastFn = (payload: ToastPayload) => void;

/**
 * Renders a TR toast for any error. Use from mutationCache.onError / queryCache.onError
 * as a fallback when components don't define their own handler. Panels inject their
 * own toast function (shadcn `toast`, sonner, etc.).
 */
export function toastFromApiError(err: unknown, toast: ToastFn): void {
  if (err instanceof ApiError) {
    toast({ variant: 'destructive', title: 'Hata', description: resolveMessage(err) });
    return;
  }
  toast({
    variant: 'destructive',
    title: 'Hata',
    description: 'Bağlantı hatası. Lütfen tekrar deneyin.',
  });
}
